import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  CssBaseline
} from '@mui/material';

import {
  ThemeProvider
} from '@mui/material/styles';

import publicTheme from '../../theme/publicTheme';

const minimalRootSx = {
  bgcolor: '#FFFFFF',
  minHeight: '100vh',
  width: '100%'
};

const minimalMainSx = {
  maxWidth: 'none',
  minHeight: '100vh',
  width: '100%'
};

const Minimal = ({ children }) => {
  return (
    <ThemeProvider theme={publicTheme}>
      <CssBaseline />

      <Box sx={minimalRootSx}>
        <Box
          component="main"
          sx={minimalMainSx}>
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

Minimal.propTypes = {
  children: PropTypes.node
};

export default Minimal;